'use client'

import { useCallback } from 'react'

import { useLenisContext } from '@/providers/Lenis'

import type { RefObject } from 'react'

interface ScrollToRefOptions {
  offset?: number
}

/**
 * Returns a function that scrolls to the element in the given ref.
 * Uses Lenis smooth scroll when available, otherwise falls back to native scrollTo.
 * Must be used within LenisProvider.
 */
export function useScrollToRef() {
  const { lenis } = useLenisContext()

  return useCallback(
    (ref: RefObject<HTMLElement | null>, options?: ScrollToRefOptions) => {
      const el = ref?.current
      if (!el) return

      if (lenis) {
        lenis.scrollTo(el, { offset: options?.offset ?? -80 })
      } else {
        el.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    [lenis],
  )
}
